import { useI18n } from '../../../i18n';
// ============================================
// RevenueByRegionPanel - Horizontal bar list with mount animation
// ============================================

import { useEffect, useState } from 'react';
import { cn } from '../../../utils/cn';
import { useMoney } from '../../../providers/CurrencyProvider';

export interface RevenueByRegionData {
  name: string;
  value: number;
  color: string;
}

interface Props {
  data: RevenueByRegionData[];
  className?: string;
}

export function RevenueByRegionPanel({ data, className }: Props) {
  const { t } = useI18n();
  const money = useMoney();
  const [animated, setAnimated] = useState(false);
  const max = Math.max(...data.map((d) => d.value), 1);

  // Trigger animation after mount
  useEffect(() => {
    const t = setTimeout(() => setAnimated(true), 100);
    return () => clearTimeout(t);
  }, []);

  const fmt = (v: number) =>
    money.format(v, { minimumFractionDigits: 0, maximumFractionDigits: 0 });

  return (
    <div className={cn('rounded-2xl bg-white p-6 shadow-sm h-full flex flex-col', className)}>
      <h3 className="mb-5 text-base font-bold text-[#191B23]">{t('revenueByRegion')}</h3>
      {/* Danh sách cửa hàng cuộn dọc: trần chiều cao ~296px canh với vùng vẽ
          của RevenueOverTimeChart bên cạnh (280px chart + legend), để panel
          không kéo dài theo số cửa hàng và tạo khoảng trắng ở biểu đồ kia. */}
      <div className="flex flex-col flex-1 min-h-0 max-h-[296px] justify-between gap-2 overflow-y-auto scrollbar-thin pr-1">
        {data.length === 0 && (
          <p className="py-8 text-center text-sm text-slate-400">{t('noRevenueInPeriod')}</p>
        )}
        {data.map((item, i) => {
          const targetWidth = (item.value / max) * 100;
          return (
            <div key={i}>
              <div className="mb-1.5 flex items-center justify-between">
                <span className="text-sm font-medium text-[#191B23]">{item.name}</span>
                <span className="text-sm font-bold text-[#0288D1]">{fmt(item.value)}</span>
              </div>
              <div className="h-3 w-full overflow-hidden rounded-full bg-[#F1F5F9]">
                <div
                  className="h-3 rounded-full"
                  style={{
                    width: animated ? `${targetWidth}%` : '0%',
                    backgroundColor: '#0288D1',
                    transition: `width 800ms cubic-bezier(0.4, 0, 0.2, 1) ${i * 80}ms`,
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
